import CityHub1 from '../City Hub/City Hub (1).webp'
import CityHub2 from '../City Hub/City Hub (2).webp'


const CityHubimages =[
CityHub1,CityHub2
]

export default CityHubimages;